<template>
    <b-row class="text-justify mb-3">
        <b-col cols="12">
            <span>Descrição: </span>
            <span>{{ notificacao.Descricao }}</span>
        </b-col>
        <b-col cols="12">
            <span>Notificado: </span>
            <span>{{ notificacao.Notificado }}</span>
        </b-col>
        <b-col cols="12" lg="6">
            <span>Unidade Gestora: </span>
            <span>{{ notificacao.UnidadeGestora }}</span>
        </b-col>
        <b-col cols="12" lg="6" v-if="responsavel">
            <span class="font-weight-bolder">Responsável Principal: </span>
            <span>{{ responsavel.Nome }}</span>
        </b-col>
        <b-col cols="12" md="6">
            <span>Código da Notificação: </span>
            <span>{{ notificacao.Notificacao }}</span>
        </b-col>
        <b-col cols="12" md="6">
            <span>Número do Processo: </span>
            <span>{{ notificacao.CodTCE }}</span>
        </b-col>
        <b-col cols="12">
            <span>Prazo de Notificação: </span>
            <span>{{ notificacao.prazoVencimento }}</span>
        </b-col>
        <b-col cols="12" md="6">
            <span>Tipo de Notificação: </span>
            <span>{{ notificacao.DescricaoTipoNotificacao }}</span>
        </b-col>
        <b-col cols="12" md="6" v-if="notificacao.DataResposta">
            <span>Data de Resposta:</span>
            <span>{{ notificacao.DataResposta }}</span>
        </b-col>
        <b-col cols="12" md="6">
            <span>Tipo de Entrada: </span>
            <span>{{ notificacao.TipoEntrada }}</span>
        </b-col>
        <b-col cols="12" v-if="tipoDocSelecionado">
            <span class="font-weight-bolder">Tipo de Documento: </span>
            <span>{{ tipoDocSelecionado.Descricao }}</span>
        </b-col>
    </b-row>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'
import { PropType } from "vue";
import { Notificacao } from '@/types/processo-eletronico/notificacao';
import { ResponsavelEtce } from '@/types/processo-eletronico/responsavel-etce';
import { TipoDocumento } from '@/types/processo-eletronico/tipo-documento';

const CompProps = Vue.extend({
    name: 'DadosComunicacaoEletronica',
    props: {
        notificacao: {
            type: Object as PropType<Notificacao>
        },
        responsavel: {
            type: Object as PropType<ResponsavelEtce>,
            required: false,
        },
        tipoDocSelecionado: {
            type: Object as PropType<TipoDocumento>,
            required: false,
        },
    },

})

@Component
export default class DetalhesRespostaComunicacao extends CompProps {}
</script>

<style scoped>
div.row>div>span:first-child {
    font-weight: bolder;
    display: block;
}
</style>
